(function () {

const indexLists = document.querySelector('.page-index__lists');
let h2Lists = document.querySelectorAll('.page-contents h2');
    h2Lists = Array.prototype.slice.call(h2Lists, 0);

let indexListContent = '';

if (h2Lists.length == 0) return;

h2Lists.forEach(function (h2, index) {
  if (!indexLists) return false;
  const id = 'index' + index;
  indexListContent += '<li><a href="#'+id+'">'+h2.innerText+'</a></li>';
  h2.innerHTML = '<a id="'+id+'" class="page-anchor"></a>'+h2.innerText;
  if (index === h2Lists.length - 1) {
    indexLists.insertAdjacentHTML('afterbegin', indexListContent);
  }
});

const observer = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    const id = entry.target.getAttribute('id');
    if (entry.intersectionRatio > 0) {
      document.querySelector(`.page-index__lists a[href="#${id}"]`).parentElement.classList.add('active');
    } else {
      document.querySelector(`.page-index__lists a[href="#${id}"]`).parentElement.classList.remove('active');
    }
  });
});
// Track all sections that have an `id` applied
document.querySelectorAll('.page-anchor').forEach((anchor) => {
  observer.observe(anchor);
});

})();
